// extracted by mini-css-extract-plugin
export default {"SettingsMobileScreen":"SettingsMobile_SettingsMobileScreen__HaXIv","heading":"SettingsMobile_heading__ampf5","tabsDiv":"SettingsMobile_tabsDiv__uyJBS"};